import React from 'react';
import { UseFormRegister } from 'react-hook-form';
import ReactHtmlParser from 'react-html-parser';
import { transformSource } from '../../../utils/helpers';

import IRules from '../../../interfaces/IRules';
import IInputs from '../../../interfaces/IInputs';
import './Checkbox.sass';

interface Props {
	inputName: 'privacy' | 'codeConduct' | 'agreement';
	label: string;
	register: UseFormRegister<IInputs>;
	rules: IRules;
	required?: boolean;
}

function Checkbox({ label, register, rules, inputName, required }: Props) {
	return (
		<label htmlFor={inputName} className="checkbox-default">
			<input
				type="checkbox"
				className="checkbox-default__input"
				id={inputName}
				/* @ts-ignre */
				{...register(inputName, rules)}
			/>
			<span className="checkbox-default__trigger">
				<img src="https://l.dataart.com/media/cn2dfgfu/check.svg" alt="Check" />
			</span>
			<span className="checkbox-default__label">
				{ReactHtmlParser(label, {
					transform: transformSource,
				})}
				{required && '*'}
			</span>
		</label>
	);
}

Checkbox.defaultProps = {
	required: false,
};

export default Checkbox;
